import { render } from "./WelcomePanel.vue?vue&type=template&id=efda4ac8&scoped=true"
const script = {}

import "@/Common/Styles/auctionModal.scss?vue&type=style&index=0&id=efda4ac8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efda4ac8"]])

export default __exports__